module.exports = __webpack_public_path__ + "img/WAPPR.c6d517f7.svg";